module.exports = __webpack_public_path__ + "static/media/store.16f27b8f.svg";